import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "app/hooks";
import Breadcrumbs from "components/@extended/Breadcrumbs";
import MainCard from "components/MainCard";
import ScrollX from "components/ScrollX";
import { NotificationsTable } from "components/tables/NotificationsTable";
import { useGetNotificationsQuery, useGetUsersQuery } from "features/api/apiSlice";
import { selectCurrentUser } from "features/auth/authSlice";
import { NavItemType } from "types/menu";
import moment from "moment";

export default function NotificationsPage() {
  const { t } = useTranslation();
  const authUser = useAppSelector(selectCurrentUser);
  
  const breadcrumbNavigation = React.useMemo<{ items: NavItemType[] }>(
    () => ({
      items: [
        {
          id: 'group-notifications',
          type: 'group',
          children: [
            {
              id: 'item-notifications',
              title: t('notifications', 'Notifications'),
              type: 'item',
              url: '/notifications'
            }
          ]
        }
      ]
    }),
    [t]
  );
  
  const { data: notifications, isLoading, isFetching } = useGetNotificationsQuery({
    from: null,
    to: moment.utc().endOf("day").toDate().toISOString(),
    readByClinician: null
  })
  const { data: users } = useGetUsersQuery({ parentId: authUser!!.id!!, role: null })

  const allUsers = authUser ? [authUser, ...(users ?? [])] : users ?? [];

  return (
    <>
      <Breadcrumbs navigation={breadcrumbNavigation} title titleBottom card={false} divider={false} />
      <MainCard content={false}>
        <ScrollX>
          <NotificationsTable notifications={notifications ?? []} users={allUsers} isSingleUser={false} isLoading={isLoading} isFetching={isFetching} />
        </ScrollX>
      </MainCard>
    </>
  )
}